module.exports = __webpack_public_path__ + "img/phoneotp.75eac780.jpg";